import { OrderEntity, MergedOrder } from '../../types/process/order';
import { OrderData } from '../../types/process/order-data';
import { ExternalReport } from '../../types/process/external-report';
import { BaseAPI } from '../manager/base';
import apiClient from '../apiClient';
import type { BaseResponse, ListResponse } from '../../types/base.dto';
import { OperationAction } from '../../types/process/operation-log';

/**
 * 订单API服务类
 * 继承BaseAPI，提供订单相关的CRUD操作及业务动作
 */
export class OrderAPI extends BaseAPI<OrderEntity> {
  constructor() {
    super('/orders');
  }

  /**
   * 获取订单列表
   * 重写以支持 MergedOrder 返回结构
   */
  // @ts-ignore
  async list(params: any): Promise<BaseResponse<ListResponse<MergedOrder>>> {
    const response = await apiClient.post<BaseResponse<ListResponse<MergedOrder>>>(`${this.endpoint}/list`, params);
    return response.data;
  }

  /**
   * 获取订单详情
   * @param orderNo 订单号
   */
  async getDetail(orderNo: string): Promise<MergedOrder | null> {
    const response = await apiClient.get<BaseResponse<MergedOrder>>(`${this.endpoint}/${orderNo}`);
    return response.data.data;
  }


  /**
   * 导出订单
   * @param params 筛选参数
   */
  async export(params: any): Promise<BaseResponse<any>> {
    const response = await apiClient.post<BaseResponse<any>>(`${this.endpoint}/export`, params);
    return response.data;
  }

  /**
   * 订单状态动作（统一入口）
   * @param orderNo 订单号
   * @param action 动作
   * @param params 动作参数
   */
  async changeStatus(orderNo: string, action: OrderAction, params?: Record<string, any>): Promise<BaseResponse<any>> {
    const response = await apiClient.post<BaseResponse<any>>(`${this.endpoint}/${orderNo}/actions`, {
      action,
      params: params || {}
    });
    return response.data;
  }

  /**
   * 取消订单
   * @param orderNo 订单号
   * @param params 取消信息
   */
  async cancelOrder(orderNo: string, params: { cancelType: string; cancelCategory: string; cancelReason: string; cancelEvidence?: string[] }): Promise<BaseResponse<any>> {
    return this.changeStatus(orderNo, OperationAction.Cancel, params);
  }

  /**
   * 获取订单统计（KPI + Tabs）
   * @param sceneGroup 场景组
   * @param params 过滤与排序参数（与列表保持一致）
   */
  async getStats(sceneGroup: string, params?: Record<string, any>): Promise<StatsResponseItem[]> {
    const response = await apiClient.post<BaseResponse<StatsResponseItem[]>>(`${this.endpoint}/stats`, {
      scene: sceneGroup,
      ...(params || {})
    });
    return response.data.data;
  }
}

export type OrderAction = OperationAction;

export interface StatsResponseItem {
  key: string;
  label: string;
  value: number;
}

// 创建订单API实例
export const orderApi = new OrderAPI();

export default orderApi;
